import Head from 'next/head';
import xss from 'xss';

import { publicGetEvent } from 'legacy/events/service';
import ViewEventProvider, {
  useViewEvent
} from 'features/events/context/ViewEvent';
import Checkout from 'features/events/checkout';

export const CheckoutPage = ({ publicEventData }) => {
  const { event } = useViewEvent();
  const eventData = event || publicEventData;

  return (
    <div>
      {eventData && (
        <Head>
          <title>{`${eventData.title} Tickets | Bounce`}</title>
          <meta property="og:type" content="website" />
          <meta property="fb:app_id" content="1855802768063770" />

          <meta
            property="og:url"
            content={`https://bouncelife.com/events/${eventData._id}`}
          />

          <meta property="og:title" content={eventData.title} />

          {eventData.photo?.url && (
            <meta property="og:image" content={eventData.photo.url} />
          )}

          <meta property="og:description" content={eventData.description} />
          <script
            type="application/ld+json"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: xss(
                JSON.stringify({
                  '@context': 'http://schema.org',
                  '@type': 'Event',
                  name: `${eventData?.title}`,
                  startDate: `${eventData?.startDate}`,
                  endDate: `${eventData?.endDate}`,
                  image: `https://bouncelife.com/events/${eventData?._id}`,
                  location: {
                    '@type': 'Place',
                    address: `${eventData?.address}`,
                    description: `${eventData?.description}`,
                    organizer: `${eventData?.host?.name}`
                  }
                })
              )
            }}
          />
        </Head>
      )}
      <Checkout />
    </div>
  );
};

CheckoutPage.getLayout = (page) => (
  <ViewEventProvider>{page}</ViewEventProvider>
);

// This is used to fetch the public event data used for SEO purposes.
CheckoutPage.getInitialProps = async ({ req, query }) => {
  if (req && query?.slug) {
    try {
      const data = await publicGetEvent(query.slug);
      return {
        publicEventData: data
      };
    } catch (err) {
      return { publicEventData: null };
    }
  }

  return { publicEventData: null };
};

export default CheckoutPage;
